import Casilla_Texto from "./CasillasDatos/Casilla_Texto";
import Casilla_Avatar_Titulo_Dato from "./CasillasDatos/Casilla_Avatar_Titulo_Dato";
import Casilla_Estado from "./CasillasDatos/Casilla_Estado";
import Casilla_Moneda from "./CasillasDatos/Casilla_Moneda";
import Casilla_Fecha_Dato from "./CasillasDatos/Casilla_Fecha_Dato";
import Casilla_Fecha_Datos from "./CasillasDatos/Casilla_Fecha_Datos";
import Casilla_Textos from "./CasillasDatos/Casilla_Textos";
import Casilla_Titulo_Dato from "./CasillasDatos/Casilla_Titulo_Dato";
import Casilla_Fecha_Dinero from "./CasillasDatos/Casilla_Fecha_Dinero";
import Casilla_Titulo_Datos from "./CasillasDatos/Casilla_Titulo_Datos";
import Casilla_Img from "./CasillasDatos/Casilla_Img";
import Casilla_Img_primera_arr from "./CasillasDatos/Casilla_Img_Primera_Arr";
import Casilla_Img_Primera_Arr from "./CasillasDatos/Casilla_Img_Primera_Arr";
import Casilla_Contar_Arr from "./CasillasDatos/Casilla_Contar_Arr";
import Casilla_Parrafo from "./CasillasDatos/Casilla_Parrafo";

export const obtenerCasilla = ({cabecera, datos, index}) => {


    switch (cabecera.tipo) {
        case CASILLA_TEXTO:
            return <Casilla_Texto key={`sd${index}`} dato={datos[cabecera.propiedad]} dir={cabecera.direccion}/>

        case CASILLA_PARRAFO:
            return <Casilla_Parrafo key={`sswd${index}`} dato={datos[cabecera.propiedad]} lineas={datos[cabecera.lineas]} dir={cabecera.direccion}/>

        case CASILLA_CONTAR_ARR:
            return <Casilla_Contar_Arr key={`sd${index}`} datos={datos[cabecera.propiedad]} dir={cabecera.direccion}/>


        case CASILLA_TEXTOS:
            return <Casilla_Textos key={`sdws${index}`} index={index} propiedades={cabecera.propiedades} datos={datos}
                                   dir={cabecera.direccion}/>
        case CASILLA_TITULO_DATO:
            return <Casilla_Titulo_Dato key={`sdww${index}`} dato={datos[cabecera.propiedad]}
                                        titulo={datos[cabecera.titulo]} dir={cabecera.direccion}/>

        case CASILLA_TITULO_DAT0S:
            return <Casilla_Titulo_Datos key={`sas${index}`} propiedades={cabecera.propiedades} datos={datos}
                                         titulo={datos[cabecera.titulo]} dir={cabecera.direccion} index={index}/>

        case CASILLA_FECHA_DATO:
            return <Casilla_Fecha_Dato key={`sdw${index}`} dato={datos[cabecera.propiedad]}
                                       fecha={datos[cabecera.fecha]} dir={cabecera.direccion}/>

        case CASILLA_FECHA_DATOS:
            return <Casilla_Fecha_Datos key={`sdws${index}`} propiedades={cabecera.propiedades} datos={datos}
                                        fecha={datos[cabecera.fecha]} dir={cabecera.direccion}/>

        case CASILLA_FECHA_DINERO:
            return <Casilla_Fecha_Dinero key={`sdsw${index}`} dato={datos[cabecera.propiedad]}
                                         fecha={datos[cabecera.fecha]} dir={cabecera.direccion}
                                         decimales={cabecera.decimales}/>


        case CASILLA_AVATAR_DOS_DATOS:
            return <Casilla_Avatar_Titulo_Dato key={`wree${index}`} img={datos[cabecera.propiedadUno]}
                                               titulo={datos[cabecera.propiedadDos]}
                                               dato={datos[cabecera.propiedadTres]} dir={cabecera.direccion}/>
        case CASILLA_ESTADO:
            return <Casilla_Estado key={`ter${index}`} estado={datos[cabecera.propiedad]} arrEstados={cabecera.estados}
                                   dir={cabecera.direccion}/>

        case CASILLA_MONEDA:
            return <Casilla_Moneda key={`fghf${index}`} dato={datos[cabecera.propiedad]} decimales={cabecera.decimales}
                                   dir={cabecera.direccion}/>


        case CASILLA_IMG:
            return <Casilla_Img key={`sd${index}`} dato={datos[cabecera.propiedad]} dir={cabecera.direccion} size={cabecera.size}
            />

        case CASILLA_IMG_PRIMERA_ARR:
            return <Casilla_Img_Primera_Arr key={`s8d${index}`} size={cabecera.size} datos={datos[cabecera.propiedad]} dir={cabecera.direccion} index={index}
            />

        default :
            return <Casilla_Texto key={`lkj${index}`} dato={datos[cabecera.propiedad]} dir={cabecera.direccion}/>

    }


}

export const CASILLA_TEXTO = 'texto'

export const CASILLA_TEXTOS = 'textos'

export const CASILLA_PARRAFO = 'parrafo'

export const CASILLA_TITULO_DATO = 'titulo_dato'

export const CASILLA_TITULO_DAT0S = 'titulo_datos'
export const CASILLA_FECHA_DATO = 'fecha_dato'

export const CASILLA_FECHA_DINERO = 'fecha_dinero'

export const CASILLA_FECHA_DATOS = 'fecha_datos'
export const CASILLA_AVATAR_DOS_DATOS = 'avatar_dos_datos'
export const CASILLA_ESTADO = 'estado'

export const CASILLA_MONEDA = 'moneda'

export const CASILLA_IMG = 'img'

export const CASILLA_IMG_PRIMERA_ARR = 'imgs'

export const CASILLA_CONTAR_ARR = 'contar'
